import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraVehicle = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraVehicle/SamsaraVehicle")
);

export const SamsaraVehiclePage = () => {
  return (
    <Layout>
      <SamsaraVehicle />
    </Layout>
  );
};
